import { Row, Spin } from 'antd/es';

export function Spinner() {
  return (
    <Row justify='space-around' align='middle' style={{ minHeight: '100vh' }}>
      <Spin size='large' />
    </Row>
  );
}
